import { Routes, Route, Navigate } from "react-router-dom";
import history from "../history";
import { CustomRouter } from "./CustomRouter";
import { paths } from "../common/constants/Rutas";
import Login from "../containers/Login/Login";
import { SeleccionarSolucion } from "../containers/SeleccionarSolucion/SeleccionarSolucion";
import Consumos from "../containers/Consumos/Consumos";
import SnackbarProvider from "../providers/snackbar";
import { PublicRoute } from "./PublicRoute";
import { PrivateRoute } from "./PrivateRoute";


function AppRouter() {
  return (
    <CustomRouter basename={paths.basename} history={history}>
      <SnackbarProvider>
        <Routes>

          <Route
            path={paths.SeleccionarSolucion}
            name="Seleccionar solución"
            element={<PublicRoute> <SeleccionarSolucion /> </PublicRoute>}
          />

          <Route
            path={paths.Login}
            name="Iniciar Sesión"
            element={<PublicRoute> <Login /> </PublicRoute>}
          />

          <Route
            path={paths.Consumos}
            name="Consumos"
            element={<PrivateRoute> <Consumos /> </PrivateRoute>}
          />

          <Route
            path="/*"
            element={<PrivateRoute>
              <Navigate
                to={paths.Consumos}
                replace
              />
              </PrivateRoute>
            }
          />

        </Routes>
      </SnackbarProvider>
    </CustomRouter>
  );
}

export default AppRouter;
